import {useState} from 'react';

const BASE_LIMIT_KEY = 'app_page_limit';
const DEFAULT_LIMIT = 15;

export type TableContext =
    'items'
    | 'packages'
    | 'orders'
    | 'recipes'
    | 'fillings'
    | 'decorations'
    | 'customers'
    | 'finances'
    | 'home';

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 25, 50, 75, 100] as const;

export function usePageLimit(table: TableContext, defaultLimit = DEFAULT_LIMIT) {
    const fullKey = `${BASE_LIMIT_KEY}_:_${table}`;

    const [limit, setLimitState] = useState<number>(() => {
        const saved = localStorage.getItem(fullKey);
        if (saved !== null) {
            const parsed = parseInt(saved, 10);
            return isNaN(parsed) ? defaultLimit : parsed;
        }
        return defaultLimit;
    });

    const changeLimit = (newLimit: number) => {
        setLimitState(newLimit);
        localStorage.setItem(fullKey, newLimit.toString());
    };

    return [limit, changeLimit] as const;
}
